import { normalizeRevisionAdviceText } from '../listing-draft-payload.js';

export function appendClientTraceCalls(functionTrace, calls = []) {
  if (!functionTrace || !Array.isArray(functionTrace.calls)) return functionTrace;
  for (const call of calls) {
    functionTrace.calls.push({ index: functionTrace.calls.length + 1, at: new Date().toISOString(), ...call });
  }
  return functionTrace;
}

export function formatRevisionUserFacingReason(reason = '') {
  const normalized = normalizeRevisionAdviceText(reason);
  const titleLimit = normalized.match(/Readable Listing (?:Product )?Title exceeds\s+(\d+)\s+characters(?:\s*\(received\s+(\d+)\))?/i);
  if (titleLimit) {
    return titleLimit[2]
      ? `候选稿主标题为 ${titleLimit[2]} 个字符，超过系统当前 ${titleLimit[1]} 字符的主标题结构限制`
      : `候选稿主标题超过系统当前 ${titleLimit[1]} 字符的主标题结构限制`;
  }
  const sectionOrder = normalized.match(/Readable Listing section is missing or out of order;\s*expected\s+(.+?),\s*received\s+(.+?)\.?$/i);
  if (sectionOrder) {
    return `候选稿区块缺失或顺序错误：应出现 ${sectionOrder[1]}，实际为 ${sectionOrder[2].replace(/\.$/, '')}`;
  }
  const endedBefore = normalized.match(/Readable Listing section ended before\s+(.+?)\.?$/i);
  if (endedBefore) {
    return `候选稿在 ${endedBefore[1].replace(/\.$/, '')} 前提前结束，缺少后续区块`;
  }
  const singleLine = normalized.match(/Readable Listing (.+?) must contain exactly one non-empty line\.?$/i);
  if (singleLine) {
    return `候选稿的 ${singleLine[1]} 必须独占一行且不能为空`;
  }
  return normalized;
}

export function renderRevisionExecutionStatus(select, { tone = 'running', title, message, taskId = '', traceId = '' } = {}) {
  const container = select('#revision-execution-status');
  if (!container) return;
  if (tone === 'success') {
    console.info('[Revision] 改稿成功', { title, message, taskId, traceId });
    container.hidden = true;
    return;
  }
  container.hidden = false;
  container.classList.remove('is-running', 'is-success', 'is-preview', 'is-error', 'is-rejected');
  container.classList.add(`is-${tone}`);
  const scoreNote = tone === 'running' ? '本轮候选稿尚未完成，暂不产生新分数；页面保留的是原稿诊断分。'
    : tone === 'rejected' ? '候选稿未写回，也未产生新分数；页面保留的是原稿诊断分。' : '';
  const titleElement = select('#revision-execution-title');
  const messageElement = select('#revision-execution-message');
  const metaElement = select('#revision-execution-meta');
  if (titleElement) titleElement.textContent = title || '改稿任务状态';
  if (messageElement) messageElement.textContent = [message, scoreNote].filter(Boolean).join(' ');
  if (metaElement) metaElement.textContent = [taskId && `taskId=${taskId}`, traceId && `traceId=${traceId}`].filter(Boolean).join(' · ');
  for (const selector of ['#revision-trace-details', '#revision-candidate-details']) {
    const details = select(selector);
    if (details) details.hidden = true;
  }
  for (const selector of ['#revision-trace-json', '#revision-candidate-json']) {
    const output = select(selector);
    if (output) output.textContent = '';
  }
}
